import React from 'react'
import api from 'api/api'
import { useAvailableTeams } from 'components/filters/useStreamFilters'
import { ITeam } from 'state/knovStore'

export default function useTeamLookup(
    teamId?: string | number | null,
    providedTeam?: ITeam | null,
): {
    team: ITeam | null
    isLoading: boolean
    isPrivateStub: boolean
} {
    const currentUser = gon.currentUser
    const teams = useAvailableTeams(currentUser)
    const normalizedTeamId =
        teamId === null || typeof teamId === 'undefined' ? null : String(teamId)

    const availableTeam = React.useMemo(() => {
        if (!normalizedTeamId) return null
        return teams.find(team => String(team.id) === normalizedTeamId) || null
    }, [normalizedTeamId, teams])

    const [fetchedTeam, setFetchedTeam] = React.useState<ITeam | null>(null)
    const [isLoading, setIsLoading] = React.useState(false)

    React.useEffect(() => {
        if (!normalizedTeamId || providedTeam || availableTeam) {
            setFetchedTeam(null)
            setIsLoading(false)
            return
        }

        let cancelled = false
        setIsLoading(true)

        api.getTeam(normalizedTeamId)
            .then(team => {
                if (cancelled) return
                setFetchedTeam(team || null)
            })
            .catch(error => {
                if (!cancelled) {
                    console.warn('Failed to load stream metadata:', error)
                    setFetchedTeam(null)
                }
            })
            .finally(() => {
                if (!cancelled) setIsLoading(false)
            })

        return () => {
            cancelled = true
        }
    }, [availableTeam, normalizedTeamId, providedTeam])

    const fetchedTeamForId =
        fetchedTeam && normalizedTeamId && String(fetchedTeam.id) === normalizedTeamId
            ? fetchedTeam
            : null
    const team = providedTeam || availableTeam || fetchedTeamForId

    return {
        team,
        isLoading,
        isPrivateStub: team?.private_stub === true,
    }
}
